import { Divider, Grid, Typography } from '@mui/material';
import React, { useContext } from 'react'
import GlobalButton from '../../utility/globalButton/button';
import popupStyles from "../../../assets/styles/componentStyles/globalPopupStyles.module.scss"
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { CommonResponseModelWODataArray, orderDetail, orderList, updatePaymentStatusPayload } from '../../../models/axiosModel';
import agent from '../../../services/api';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface UpdatePaymentStatusPopup {
    selectedOrder: orderList | null,
    onCloseOfUpdateStatusPopup: () => void,
   updateOrderPaymentStatus: (orderId: string) => Promise<void>,
} 

const UpdatePaymentStatusPopup: React.FC<UpdatePaymentStatusPopup> = (props) => {
    
    const { selectedOrder, onCloseOfUpdateStatusPopup, updateOrderPaymentStatus } = props;
    const {  setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const onClickOfSaveBtn = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const payload: updatePaymentStatusPayload = {
            order_id: selectedOrder?.order_id ?? '',
            ecom_order_payment_status: 'paid'
        }

        const res = await agent.updatePaymentStatus.put(payload);
        if(!(res?.status)){
            handleError(res);
        } else {
            showSuccess('Payment Status Updated Successfully')
            updateOrderPaymentStatus(selectedOrder?.order_id ?? '');
            onCloseOfUpdateStatusPopup();
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    return (
        <>
            <Grid xs={12}>
                <Grid container direction={"column"} justifyContent={"center"}>
                    <Grid item textAlign={"center"}>
                        <Typography className={popupStyles.popupTitleTypography}>
                            {`Update Payment Status - Order #${selectedOrder?.order_source_reference_id}`}
                        </Typography>
                    </Grid>

                    <Divider className={popupStyles.popupTitleDivider} />

                    <Grid item xs={12} className={popupStyles.popupBodyGridContainer}>
                        <Typography className={popupStyles.popupFieldTypography}>
                            Are you sure you want to update the Payment status to "Paid"?
                        </Typography>
                    </Grid>

                    <Grid item>
                        <Grid container justifyContent={"center"} alignItems={"center"} gap={"12px"} sx={{ padding: "20px 0" }}>
                            <Grid item>
                                <GlobalButton
                                    buttonText="Cancel"
                                    sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                    className='borderedButtonStyle'
                                    onClick={() => onCloseOfUpdateStatusPopup()}
                                />
                            </Grid>
                            <Grid item>
                                <GlobalButton
                                    buttonText="Update"
                                    sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                    className='primaryButtonStyle'
                                    onClick={() => onClickOfSaveBtn()}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid> 
        </>
    )
}

export default UpdatePaymentStatusPopup
